/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "InertialManager", {
  enumerable: true,
  get: function get() {
    return _InertialManager.default;
  }
});
exports.default = void 0;
var _InertialScroller = _interopRequireDefault(require("./InertialScroller"));
var _InertialManager = _interopRequireDefault(require("./InertialManager"));
var _default = _InertialScroller.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/InertialScroller/src/index.js
// module id = 690
// module chunks = 0